<template>
    <transition name="kb-embed-panel-fade">
        <div v-if="visible" class="embedding-progress-panel">
            <div class="panel-card" :class="{ 'panel-card--dual': showUpload && showEmbedding }">
                <div v-if="showUpload" class="panel-segment panel-segment--upload">
                    <div class="segment-icon">
                        <i class="material-icons">cloud_upload</i>
                    </div>
                    <div class="segment-body">
                        <div class="segment-title">{{ $t("chatbotv2.embeddingPanelUploadTitle") }}</div>
                        <a-progress
                            :percent="uploadPercent"
                            :stroke-color="{ '0%': '#1890ff', '100%': '#40a9ff' }"
                            status="active"
                        />
                        <div v-if="uploadTotal > 1" class="segment-meta">
                            {{ uploadCompleted }} / {{ uploadTotal }} {{ $t("chatbotv2.filesCompleted") }}
                        </div>
                        <div class="segment-hint">
                            <i class="material-icons">info</i>
                            {{ $t("chatbotv2.dontLeavePageUpload") }}
                        </div>
                    </div>
                </div>
                <div v-if="showUpload && showEmbedding" class="panel-divider" />
                <div v-if="showEmbedding" class="panel-segment panel-segment--embed">
                    <div class="segment-icon">
                        <i class="material-icons">auto_awesome</i>
                    </div>
                    <div class="segment-body">
                        <div class="segment-title">{{ $t("chatbotv2.embeddingPanelTitle") }}</div>
                        <a-progress
                            :percent="embedPercent"
                            :stroke-color="{ '0%': '#52c41a', '100%': '#95de64' }"
                            status="active"
                        />
                        <div class="segment-meta">
                            {{ embedCompleted }} / {{ embedTotal }} · {{ embedPercent }}%
                        </div>
                        <div class="segment-hint">
                            <i class="material-icons">info</i>
                            {{ $t("chatbotv2.dontLeaveWhileEmbedding") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "EmbeddingProgressPanel",
    props: {
        visible: { type: Boolean, default: false },
        showUpload: { type: Boolean, default: false },
        uploadPercent: { type: Number, default: 0 },
        uploadCompleted: { type: Number, default: 0 },
        uploadTotal: { type: Number, default: 0 },
        showEmbedding: { type: Boolean, default: false },
        embedPercent: { type: Number, default: 0 },
        embedCompleted: { type: Number, default: 0 },
        embedTotal: { type: Number, default: 0 },
    },
});
</script>
<style scoped lang="scss">
.kb-embed-panel-fade-enter-active,
.kb-embed-panel-fade-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}
.kb-embed-panel-fade-enter,
.kb-embed-panel-fade-leave-to {
    opacity: 0;
    transform: translateY(-6px);
}

.embedding-progress-panel {
    width: 100%;
    margin-bottom: 20px;
    z-index: 5;
}

.panel-card {
    display: flex;
    flex-direction: column;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid rgba(34, 39, 45, 0.08);
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(34, 39, 45, 0.06), 0 2px 8px rgba(34, 39, 45, 0.04);
    overflow: hidden;

    &--dual {
        flex-direction: row;
        flex-wrap: wrap;

        .panel-divider {
            width: 1px;
            background: rgba(34, 39, 45, 0.08);
            align-self: stretch;
            min-height: 120px;
        }

        .panel-segment {
            flex: 1;
            min-width: 240px;
        }
    }
}

.panel-segment {
    display: flex;
    gap: 16px;
    padding: 20px 22px;
    align-items: flex-start;

    &--upload .segment-icon {
        background: rgba(24, 144, 255, 0.12);
        color: #1890ff;
    }

    &--embed .segment-icon {
        background: rgba(82, 196, 26, 0.12);
        color: #389e0d;
    }
}

.segment-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .material-icons {
        font-size: 26px;
    }
}

.segment-body {
    flex: 1;
    min-width: 0;
}

.segment-title {
    font-size: 15px;
    font-weight: 700;
    color: #22272d;
    letter-spacing: -0.02em;
    margin-bottom: 10px;
}

.segment-meta {
    font-size: 13px;
    color: #5c6570;
    margin-top: 8px;
    font-weight: 500;
}

.segment-hint {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 10px;
    font-size: 12px;
    color: #8c959c;

    .material-icons {
        font-size: 16px;
        color: #1890ff;
    }
}

.panel-divider {
    display: none;
}

@media (min-width: 640px) {
    .panel-card--dual .panel-divider {
        display: block;
    }
}
</style>
